module.exports = __webpack_public_path__ + "img/btn-save-th.e604062d.png";